export const queryKeys = {
  cases: {
    all: ["cases"] as const,
    lists: ["cases", "list"] as const,
    search: (filters: Record<string, unknown>) =>
      ["cases", "list", "search", filters] as const,
    detail: (id: string) => ["cases", "detail", id] as const,
    message: (caseId: string, messageId: string) =>
      ["cases", "detail", caseId, "message", messageId] as const,
    summary: (id: string) => ["cases", "summary", id] as const,
    journal: (id: string) => ["cases", "journal", id] as const,
    events: (id: string) => ["cases", "events", id] as const,
    stepDocs: (caseId: string, stepId: string) =>
      ["cases", "step-documents", caseId, stepId] as const,
    stepDocAssets: (caseId: string, stepId: string, docId: string) =>
      ["cases", "step-document-assets", caseId, stepId, docId] as const,
    byRequestId: (requestId: string) =>
      ["cases", "list", "by-request", requestId] as const,
    searchSimple: (q: string) =>
      ["cases", "list", "simple-search", q] as const,
  },
  requests: {
    all: ["requests"] as const,
    search: (filters: Record<string, unknown>) =>
      ["requests", "search", filters] as const,
    detail: (id: string) => ["requests", id] as const,
    latest: (limit: number) => ["requests", "latest", limit] as const,
    searchSimple: (q: string) => ["requests", "searchSimple", q] as const,
  },
  users: {
    all: ["users"] as const,
    search: (filters: Record<string, unknown>) =>
      ["users", "search", filters] as const,
    detail: (id: string) => ["users", id] as const,
    summary: (id: string) => ["users", id, "summary"] as const,
    avatar: (id: string) => ["users", id, "avatar"] as const,
    searchSimple: (q: string) => ["users", "searchSimple", q] as const,
    cases: (userId: string, pageIndex: number, pageSize: number) =>
      ["users", userId, "cases", pageIndex, pageSize] as const,
    requests: (userId: string, pageIndex: number, pageSize: number) =>
      ["users", userId, "requests", pageIndex, pageSize] as const,
    vehicles: (userId: string, pageIndex: number, pageSize: number) =>
      ["users", userId, "vehicles", pageIndex, pageSize] as const,
  },
  vehicles: {
    all: ["vehicles"] as const,
    search: (filters: Record<string, unknown>) =>
      ["vehicles", "search", filters] as const,
    detail: (id: string) => ["vehicles", id] as const,
    summary: (id: string) => ["vehicles", id, "summary"] as const,
  },
  sources: {
    all: ["sources"] as const,
  },
  persons: {
    detail: (id: string) => ["persons", id] as const,
  },
  policies: {
    detail: (id: string) => ["policies", id] as const,
  },
  assets: {
    detail: (id: string) => ["assets", id] as const,
  },
  account: {
    detail: ["account"] as const,
    adminAccess: (userId: string) =>
      ["account", userId, "admin-access"] as const,
    notifications: ["account", "notifications"] as const,
    unreadCount: ["account", "notifications", "unread"] as const,
    notificationPreferences: ["account", "notification-preferences"] as const,
  },
  appointments: {
    all: ["appointments"] as const,
    list: (filters: Record<string, unknown>) =>
      ["appointments", "list", filters] as const,
    detail: (id: string) => ["appointments", id] as const,
    availability: (
      userId: string,
      from: string,
      to: string,
      slotMinutes?: number
    ) =>
      ["appointments", "availability", userId, from, to, slotMinutes] as const,
  },
  caseTypes: ["case-types"] as const,
  caseTypeTemplate: (id: string) =>
    ["case-types", id, "template"] as const,
  roles: ["roles"] as const,
  stepTemplates: (caseTypeId: string) =>
    ["step-templates", caseTypeId] as const,
  stepTemplateNameSuggestions: ["step-templates", "name-suggestions"] as const,
  stepTemplateDetails: (id: string) =>
    ["step-templates", id, "details"] as const,
  stepTemplateDocuments: (id: string) =>
    ["step-templates", id, "documents"] as const,
  stepTemplateDocumentClientTexts: (templateId: string, documentId: string) =>
    [
      "step-templates",
      templateId,
      "documents",
      documentId,
      "client-texts",
    ] as const,
  events: {
    all: ["events"] as const,
    list: (filters: Record<string, unknown>) =>
      ["events", "list", filters] as const,
    detail: (id: string) => ["events", id] as const,
    attendees: (id: string) => ["events", id, "attendees"] as const,
  },
  eventTemplates: {
    all: ["event-templates"] as const,
    list: (caseTypeId: string) =>
      ["event-templates", caseTypeId] as const,
    detail: (id: string) => ["event-templates", id] as const,
  },
  statistics: ["statistics"] as const,
  timeseries: (range: string) => ["statistics", "timeseries", range] as const,
};
